
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Button,
    Dialog,
    Slide,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MicrosoftIcon from "@mui/icons-material/Microsoft";
import GoogleIcon from "@mui/icons-material/Google";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import {useTheme} from '@mui/material/styles';
import {ListViewModel,
        ListViewColumnModel,
        RecordModel} from '../../models/models';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {useSnackbar} from "notistack";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import {Link, useParams, useLocation} from 'react-router-dom';
import {getAppName, getObjectName } from "../../utils/helperRouter";
import Config from "../../config";
import { useAuth } from "../../hooks/useAuth";

class EmailClient {

  label: string;
  loginUrl: string;

  constructor(
    label: string = "",
    loginUrl: string = ""
  ) {
    this.label = label;
    this.loginUrl = loginUrl;
  }

  fromJSON(json: any): EmailClient {
    const label = json.Label_c;
    const loginUrl = json.login_url;

    return new EmailClient(label, loginUrl)
    }
}



export const ConnectEmailComponent: React.FC<{
  data: any
}> = ({
  data
}) => {

  const styles = ContainerClasses();

  let {appName, objectName, recordUuid} = useParams();

  const { enqueueSnackbar } = useSnackbar();

  const [emailClients, setEmailClients] = useState<EmailClient[]>([]);
  const [isLoading, setIsLoading] = useState<Boolean>(false);

  useEffect(() => {
    const broadcastChannel = new BroadcastChannel("oauth_channel");

    broadcastChannel.onmessage = (event) => {
      if(event.data?.type === "OAUTH_RESULT"){
        if(event.data.status === "success"){
          enqueueSnackbar("Email connected", {
            variant: "success",
          });

          setTimeout(() => {
            window.location.reload();
          }, 500);

        } else {
          enqueueSnackbar("Unhandled error occured during email connection: Please retry or contact your system administrator.", {
            variant: "error",
          });
        }
      }

    }

    return () => {
      broadcastChannel.close();
    }

  }, []);

  useEffect(() => {
    if(data && data.email_clients){
      const thisEmailClients = data.email_clients.map((this_json: any) => new EmailClient().fromJSON(this_json));
      setEmailClients(thisEmailClients);
    }
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

//  const handleClick = (url: string) => {
//    window.open(url, '_blank', 'noopener,noreferrer')
//  }

  const handleClick = (url: string) => {
    setIsLoading(true);

    const popup = window.open(
      url,
      "OauthLogin",
      "width=500,height=600"
    )

    if(!popup){
     enqueueSnackbar("Please allow popups for this page", {
          variant: "error",
       });
    }
/*
    const poll = setInterval(() => {
      if (popup?.closed) {
        clearInterval(poll);
        setIsLoading(false);
      }
    }, 500);
    */
  };


  const EmailClientButton = (emailClient: EmailClient) => {

    return (
       <Box sx={styles.containerColB}>

         <Button
           variant="contained"
           sx={{width: '70%'}}
           onClick={() => handleClick(emailClient.loginUrl)}
         >
           <Box sx={styles.containerRowB}>
             <Typography
               variant="h6"
             >
               Login to Email Client: {emailClient.label}
             </Typography>

             {emailClient.loginUrl.includes("microsoft") &&
               <MicrosoftIcon/>
             }
             {emailClient.loginUrl.includes("google") &&
               <GoogleIcon/>
             }
           </Box>
         </Button>

       </Box>
    )

  }




  return (
    <Box sx={{height: '66%'}}>
    {
      emailClients.map((emailClient) => EmailClientButton(emailClient))
    }
    </Box>
  );

};
